import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "../../box/src";
import { CATEGORIES, FontAwesomeIconWithBackground, } from "../../font-awesome-icon/src";
const DEFAULT_FA_PROPS = {
    bg: true,
    color: 'primary',
    height: '72px',
    iconName: 'icons',
    iconType: CATEGORIES.DUOTONE,
};
export const CardIcon = ({ faIconProps }) => {
    const computedFaProps = Object.assign(Object.assign({}, DEFAULT_FA_PROPS), faIconProps);
    return (_jsx(Box, { alignSelf: "flex-start", children: _jsx(FontAwesomeIconWithBackground, Object.assign({}, computedFaProps)) }));
};
//# sourceMappingURL=CardIcon.js.map